
import Routes from './services/routes'

function App() {
  return (
   <Routes />
  );
}

export default App;
